import React from "react";
import { DefaultContext } from "react-icons/lib";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const DoneStep = ({ soundClick }) => {
    const { t } = useLanguage()
    const navigate = useNavigate()

    const handleGoDashboard = () => {
        soundClick()
        navigate("/console")
    }

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.done.title}</p>
                    <p className="step_description fade-in">{t.onboarding.done.subtitle}</p>
                    <button className="mainframe_item_create_btn fade-in mainframe_item_create_btn_anim" onClick={handleGoDashboard}>{t.onboarding.done.open_dashboard}</button>
                </div>
            </div>
        </div>
    )
}

export default DoneStep